import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Company } from '../index';
import { useAppMutation } from '../use-app-mutation.hook';
import { CreateSharedCapTableLinkDto, SharedCapTableLink } from './shared-cap-table.types';

export const useSharedCapTableLinkCreate = () => {
  const queryClient = useQueryClient();
  const { selectedCompanyId: companyId } = Company.useSelected();

  const { isPending, mutate: createLink } = useAppMutation<
    SharedCapTableLink,
    unknown,
    CreateSharedCapTableLinkDto
  >([QueryKey.SHARED_CAP_TABLE_LINK_CREATE, companyId], {
    mutationFn: (data) =>
      ApiService.post<SharedCapTableLink>(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'shared-cap-table-links'] },
        { body: data },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.SHARED_CAP_TABLE_LINKS] });
    },
  });

  return { createLink, isPending };
};
